<template>
    <v-menu offset-y open-on-hover>
        <!--                <template v-slot:activator="{ on, attrs }">-->
        <!--                    <v-btn
                            tag="a" class="link-menu" height="46" text v-bind="attrs" v-on="on">-->
        <!--                        <v-icon :color="$vuetify.theme.dark ? '' : '#867878'">mdi-help-circle-outline</v-icon>-->
        <!--                    </v-btn>-->
        <!--                </template>-->

        <template v-slot:activator="{ on: activationEvents }">
            <v-btn
                tag="a"
                :height="$vuetify.breakpoint.xs ? 30 : 46"
                min-width="30"
                :width="$vuetify.breakpoint.xs ? 30 : 50"
                class="link-menu"
                text
                v-on="activationEvents"
            >
                <v-icon :color="$vuetify.theme.dark ? '' : '#867878'">mdi-help-circle-outline</v-icon>
            </v-btn>
        </template>

        <v-list class="pa-1 rounded" nav>
            <v-list-item-group v-model="selection['help']">
                <div v-for="item in items" :key="item.title" class="pb-1">
                    <router-link :to="{ name: item.link }" class="blackText">
                        <v-list-item class="" :class="[item.link === $route.name ? 'v-item--active v-list-item--active' : '']" @click="clear">
                            <v-list-item-content class="">
                                <v-list-item-title class="font-weight-medium">
                                    {{ $t('menu.' + item.title) }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </router-link>
                </div>
                <a
                    v-if="utils.getPlatform() !== $const.PLATFORM_TRADEBALL && $i18n.locale === 'pt'"
                    target="“_blank”"
                    class="cursorPointer blackText"
                    href="https://www.youtube.com/@Tradeball"
                >
                    <v-list-item class="mb-1">
                        <v-list-item-content class="">
                            <v-list-item-title class="font-weight-medium">
                                <v-img contain :src="'/images/youtube.png'" width="25" height="25"></v-img>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </a>
                <a v-if="utils.getPlatform() === $const.PLATFORM_TRADEBALL" class="cursorPointer blackText" href="mailto:support@tradeball.com">
                    <v-list-item class="mb-1">
                        <v-list-item-content class="">
                            <v-list-item-title class="font-weight-medium">
                                {{ $t('menu.support') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </a>
            </v-list-item-group>
        </v-list>
    </v-menu>
</template>
<style scoped></style>
<script>
    export default {
        name: 'app-menuHelp',

        props: {
            items: [],
        },

        created() {
            console.log('Component %s was created.', this.$options.name);
        },

        mounted() {
            console.log('Component %s mounted.', this.$options.name);
        },

        methods: {
            clear() {
                this.selection = [];
            },
        },

        computed: {
            selection: {
                get() {
                    return this.$store.getters['MenuModule/getSelection'];
                },
                set(value) {
                    this.$store.commit('MenuModule/setSelection', value);
                },
            },
        },
    };
</script>
